import { theme } from '@conviva/vision-antd';

export const ANTD_THEME = {
  token: {
    ...theme.vision.token,
    // borderRadius: 0,
  },
  components: {
    Select: {
      borderRadius: 2,
    },
    Button: {
      borderRadius: 2,
      borderRadiusLG: 4,
    },
    InputNumber: {
      borderRadius: 2,
    },
    Input: {
      borderRadius: 2,
    },
    TextArea: {
      borderRadius: 2,
    },
    Radio: {
      borderRadius: 2,
    },
    DatePicker: {
      borderRadius: 2,
    },
  },
};
